export const getCoords = e => (
  e.touches ? ({
    x: e.touches[0].clientX,
    y: e.touches[0].clientY,
  }) : ({
    x: e.clientX,
    y: e.clientY,
  })
);

export const getEventData = ({
  startCoords = {
    x: 0,
    y: 0,
  },
  currentCoords = {
    x: 0,
    y: 0,
  },
}) => {
  const xDiff = startCoords.x - currentCoords.x;
  const yDiff = startCoords.y - currentCoords.y;
  const xDiffAbs = Math.abs(xDiff);
  const yDiffAbs = Math.abs(yDiff);
  const swipedLeft = xDiffAbs > yDiffAbs && xDiff > 0;
  const swipedRight = xDiffAbs > yDiffAbs && xDiff < 0;
  const swipedUp = xDiffAbs < yDiffAbs && yDiff > 0;

  if (swipedLeft) {
    return {
      direction: 'left',
      absDistance: xDiffAbs,
      distance: xDiff,
      currentX: currentCoords.x,
      currentY: currentCoords.y,
    };
  }

  if (swipedRight) {
    return {
      direction: 'right',
      absDistance: xDiffAbs,
      distance: xDiff,
      currentX: currentCoords.x,
      currentY: currentCoords.y,
    };
  }

  if (swipedUp) {
    return {
      direction: 'up',
      absDistance: yDiffAbs,
      distance: yDiff,
      currentX: currentCoords.x,
      currentY: currentCoords.y,
    };
  }

  return {
    direction: 'down',
    absDistance: yDiffAbs,
    distance: yDiff,
    currentX: currentCoords.x,
    currentY: currentCoords.y,
  };
};
